import React, {useEffect, useState} from "react";
import Chart from 'react-apexcharts'

export const BubblechartPreview = (props) => {
    const [chartData, setChartData] = useState({
        series: [],
        options: {
            chart: {
                type: 'bubble',
            },
            labels: [],
        },
    });


    useEffect(() => {
        setChartData(formatProps(props));
    }, [props]);


    const formatProps = (props)=>{

        let series = [];


        return {
            series: [
                {
                    name: 'Pagos QR',
                    data: [
                        [new Date().setDate(new Date().getDate() - 8),90,5],
                        [new Date().setDate(new Date().getDate() - 8),120,5],
                        [new Date().setDate(new Date().getDate() - 8),110,5],
                        [new Date().setDate(new Date().getDate() - 8),150,5],
                    ],
                }
            ],
            options: {
                legend: {
                    show: props.showLegend === "Y",
                    position: props?.legendPosition ?? '',
                    horizontalAlign: 'center',
                    floating: false,
                    fontSize: '14px',
                    fontFamily: props.fontFamily,
                    fontWeight: 400,
                    formatter: undefined,
                    inverseOrder: false,
                    tooltipHoverFormatter: undefined,
                    customLegendItems: [],
                    offsetX: 0,
                    offsetY: 0,
                    labels: {
                        colors: undefined,
                        useSeriesColors: false
                    },
                    markers: {
                        size: 4,
                    },
                    itemMargin: {
                        horizontal: 5,
                        vertical: 0
                    },
                    onItemHover: {
                        highlightDataSeries: true
                    },
                },
                tooltip: {
                    enabled: false,
                },
                dataLabels: {
                    enabled: false,
                },
                fill: {
                    opacity: 0.8,
                },
                yaxis: {
                    min:0,
                    max:200,
                },
                xaxis:{
                    min: new Date().setDate(new Date().getDate() - 30),
                    max: new Date().setDate(new Date().getDate() + 1),

                },
                colors: props.seriesColor,
                chart: {
                    background: props.colorBackground,
                    fontFamily: props.fontFamily,
                    height: 300,
                    width: 300,
                    type: 'bubble',
                }
            }
        }
    }

    return (
        <div>
            <div>
                <Chart options={chartData?.options ?? []}
                       series={chartData?.series ?? []}
                       type={'bubble'}
                       width={400} />

            </div>


            <div id="html-dist"></div>
        </div>
    );
}
